import { ThunkAction } from "redux-thunk";
import { AppState, AppActions } from "../Store/store";
import { adminApi } from "../api";

// State
interface IUserState {
  email: string,
  avatar: string,
  level: number,
  id: number,
  status: 'loading' | 'loaded'
}

const initialState: IUserState = {
  email: '',
  avatar: '',
  level: 0,
  id: 0,
  status: 'loading'
}

// Selectors
export const userSelector = (state: any) => state.user;
export const userStatusSelector = (state: any) => state.user.status;
export const userLevelSelector = (state: any) => state.user.level;

// Action types
export const SET_USER = 'user/SET_USER';
export const SET_USER_STATUS = 'user/SET_USER_STATUS';

export function userReducer(state: IUserState = initialState, action: any) {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        email: action.payload.email,
        avatar: action.payload.avatar || '',
        level: action.payload.level,
        id: action.payload.id
      }

    case SET_USER_STATUS:
      return {
        ...state,
        status: action.payload

      }
    default:
      return state;
  }
}

// Actions
interface GetProfileType {
  type: typeof SET_USER,
  payload: any
}
export function getProfile(): ThunkAction<Promise<void>, AppState, unknown, AppActions> {
  return async (dispatch) => {
    const response = await adminApi.getProfile();
    dispatch(setUserStatus('loading'));
    dispatch({
      type: SET_USER,
      payload: response
    });
    dispatch(setUserStatus('loaded'));
  }
}

interface SetUserStatusType {
  type: typeof SET_USER_STATUS,
  payload: string
}
export function setUserStatus(payload: string): SetUserStatusType {
  return {
    type: SET_USER_STATUS,
    payload
  }
}

export type UserActions =
  SetUserStatusType
  | GetProfileType;